import React, { lazy } from 'react';
import { motion } from 'framer-motion';
export function SolutionSection() {
  return <section className="py-16 md:py-24 bg-transparent" data-id="element-178">
      <div className="container mx-auto px-4 max-w-4xl text-center" data-id="element-179">
        <div className="mb-10" data-id="element-180">
          <span className="inline-block px-6 py-2.5 mb-5 rounded-full border border-white/40 bg-[#4A553F] text-white font-semibold tracking-[0.18em] uppercase text-xs" data-id="element-181">
            LA SOLUCIÓN QUE ESPERABAS — UN SISTEMA TODO EN UNO
          </span>
          <h2 className="font-heading md:text-5xl font-bold text-[#2f3a2c] mb-6 max-w-3xl mx-auto text-[28px] leading-tight" data-id="element-182">
            El único sistema que tu gestión de HyS necesita para funcionar con{' '}
            <span className="text-[#5C6851] italic" data-id="element-183">
              orden, respaldo y control real
            </span>
          </h2>
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-10" data-id="element-184">
          <img src="https://cdn.magicpatterns.com/uploads/38Zw7KxJdj8RJzWLP42Fty/Texto_del_parrafo_(10).webp" alt="Mega Pack Higiene y Seguridad Blindada" width={672} height={672} loading="lazy" decoding="async" sizes="(max-width: 768px) 100vw, 672px" className="w-full h-auto max-w-2xl mx-auto rounded-2xl shadow-xl shadow-navy/5 border border-slate-100" data-id="element-185" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-white/60 border border-amber-100 text-[#2f3a2c] rounded-3xl p-8 md:p-10 shadow-sm" data-id="element-186">
          <p className="md:text-xl font-medium text-slate-700 text-[16px]" data-id="element-187">
            <span className="text-[#5C6851] font-bold italic" data-id="element-188">
              MEGA PACK HIGIENE Y SEGURIDAD
            </span>{' '}
            No es un simple pack de documentos. Es un sistema completo para
            organizar tu trabajo con herramientas listas para usar desde el
            primer día. Sin software. Sin cursos largos. Sin complicaciones.
          </p>
        </motion.div>
      </div>
    </section>;
}